// extracted by mini-css-extract-plugin
export default {"formSubmit":"index_formSubmit_T9WAJ","formSubmitSave":"index_formSubmitSave_gmGnw","formSubmitButton":"index_formSubmitButton_kn4eC"};